var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { memo } from "react";
const SvgNp6 = _ref => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 42,
    viewBox: "0 0 32 42",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M5.278 37.509C2.174 34.384.162 30.366.162 22.126.162 9.83 6.162.232 17.665.232c4.228 0 7.33.893 9.986 2.698 1.091.892 1.976 1.785 1.976 3.125 0 1.785-1.55 3.348-3.527 3.348-.683 0-1.345-.223-1.772-.688-2.215-1.34-4.228-2.233-6.866-2.233-6 0-9.528 5.58-9.75 12.947 1.978-2.214 4.876-4.018 9.75-4.018 7.754 0 13.955 4.464 13.955 12.5v.223c0 8.036-6.422 13.616-14.843 13.616-5.112 0-8.64-1.562-11.296-4.241m19.05-9.134c0-4.018-3.1-7.143-8.215-7.143-5.077 0-8.179 3.348-8.179 7.143 0 4.24 3.305 7.366 8.42 7.366 4.874 0 7.974-3.125 7.974-7.366",
    clipRule: "evenodd"
  })));
};
const Memo = /*#__PURE__*/memo(SvgNp6);
export default Memo;